import ApiService from './ApiService.js'



export default {
    getHeader() {
        return {
            "Authorization": "Bearer " + localStorage.getItem('access_token'),
            'Content-Type': 'application/json',
            "Accept": "application/json"
        };
    },
    getHeaderMultipart() {
        return {
            "Authorization": "Bearer " + localStorage.getItem('access_token'),
            'Content-Type': 'multipart/form-data'
        };
    },
    get(offset, limit) {
        if(!limit)
            limit = 25;
        if(!offset)
            offset = 0;
        let header = this.getHeader();
        return ApiService().get('api/computers/' + offset + '/'+ limit,
        { 
            headers: header
        });
    },
    ping(id) {
        let header = this.getHeader();
        return ApiService().get('api/computers/ping/' + id,
        { 
            headers: header
        });
    },
    wake(id) {
        let header = this.getHeader();
        return ApiService().get('api/computers/wake/' + id,
        { 
            headers: header
        });
    },
    shutdonwn(id) {
        let header = this.getHeader();
        return ApiService().get('api/computers/shutdonwn/' + id,
        { 
            headers: header
        });
    },
    getById(id) {
        let header = this.getHeader();
        return ApiService().get('api/computers/' + id,
        { 
            headers: header
        });
    },
    update(data) {
        let header = this.getHeader();
        return ApiService().put('api/computers', data,
        { 
            headers: header
        });
    },
    insert(data) {
        let header = this.getHeader();
        return ApiService().post('api/computers', data,
        { 
            headers: header
        });
    },
    delete(id) {
        let header = this.getHeader();
        return ApiService().delete('api/computers/' + id,
        { 
            headers: header
        });
    },
    uploadImage(id, data) {
        let header = this.getHeaderMultipart();
        return ApiService().post('api/computers/' + id + '/image', data,
        { 
            headers: header
        });
    }
}